import { render, staticRenderFns } from "./InscriptionChart.vue?vue&type=template&id=b20805de"
import script from "./InscriptionChart.vue?vue&type=script&lang=js"
export * from "./InscriptionChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports